const Checkout = {
    shoppingBagSummaryTitle: "checkout.shoppingBag.summary.title",
    shoppingBagTitle: "checkout.shoppingBag.title",
    requiredFieldError: "checkout.error.requiredField",
    requiredFieldDynamic: "checkout.error.requiredFieldDynamic",
    emptyBagText: "checkout.emptyBagText",
    headline: "checkout.ariaheadline",
    toggleNewsLetter: "checkout.ariaToggleNewsletter",
    step1: {
        title: "checkout.step1.title",
        formEmail: {
            title: "checkout.step1.formEmail.title",
            error: "checkout.step1.formEmail.error",
            suggestion: "checkout.step1.emailSuggestion",
            originIsCorrect: "checkout.step1.emailIsCorrect",
        },
        formCountry: {
            title: "checkout.step1.formCountry.title",
        },
        formPhone: {
            title: "checkout.step1.formPhone.title",
            reasonForInsert: "checkout.step1.formPhone.reasonForInsert",
            error: "checkout.step1.formPhone.error",
        },
        button: {
            title: "checkout.step1.button.continueToDelivery",
        },
        policy: {
            error: "checkout.step1.policy.error",
        },
        contactDetails: {
            error: "checkout.step1.contactDetails.error",
        },
        delivery: {
            error: "checkout.step1.delivery.error",
        },
    },
    step2: {
        title: "checkout.step2.title",
        deliveryMethod: "checkout.step2.deliveryMethod.title",
        missingDeliveryMethodError: "checkout.step2.deliveryMethod.missing.error",
        unavailableDeliveryMethodForHazardousProductsError:
            "checkout.step2.deliveryMethod.hazardousProducts.error",
        storeUnavailableError: "checkout.step2.deliveryMethod.storeUnavailable.error",
        paymentError: {
            addressValidation: "checkout.step2.addressValidation.error",
            nameMissing: "checkout.step2.nameMissing.error",
            addressObjectMissing: "checkout.step2.addressObjectMissing.error",
        },
        shippingAddress: "checkout.step2.shippingAddress.title",
        billingAddress: "checkout.step2.billingAddress.title",
        formAddress: {
            title: "checkout.step2.formAddress",
            error: "checkout.step2.formAddress.error",
        },
        formAddressLine2: "checkout.step2.formAddressLine2",
        addAddressLine: "checkout.step2.addAddressLine",
        addressesMatch: "checkout.step2.addressesMatch",
        formFirstName: {
            title: "checkout.step2.formFirstName",
            error: "checkout.step2.formFirstName.error",
        },
        formLastName: {
            title: "checkout.step2.formLastName",
            error: "checkout.step2.formLastName.error",
        },
        formCity: {
            title: "checkout.step2.formCity",
            containsNumbersError: "checkout.step2.formCity.containsNumbers",
        },
        formZipCode: {
            title: "checkout.step2.formZipCode.title",
            formateError: "checkout.step2.formZipCode.formate",
            validError: "checkout.step2.formZipCode.valid",
        },
        formCountry: {
            title: "checkout.step2.formCountry.title",
            error: "checkout.step2.formCountry.error",
        },
        button: {
            title: "checkout.step2.button.continueToPayment",
        },
        customValidation: {
            confirmAddress: "checkout.step2.customValidation.confirmAddress",
            suggestedChangesDescription:
                "checkout.step2.customValidation.suggestedChangesDescription",
            invalidAddressDescription: "checkout.step2.customValidation.invalidAddressDescription",
            missingHouseNumberDescription:
                "checkout.step2.customValidation.missingHouseNumberDescription",
            addressDoublecheckHint: "checkout.step2.customValidation.addressDoublecheckHint",
            saveAndContinue: "checkout.step2.customValidation.saveAndContinue",
            /** Short "Edit" link inside the address box; editAddress is the longer US label. */
            edit: "checkout.step2.customValidation.edit",
            youEntered: "checkout.step2.customValidation.youEntered",
            weSuggest: "checkout.step2.customValidation.weSuggest",
            useDifferentAddress: "checkout.step2.customValidation.useDifferentAddress",
            useEnteredAddress: "checkout.step2.customValidation.useEnteredAddress",
            useUpdatedAddress: "checkout.step2.customValidation.useUpdatedAddress",
            editAddress: "checkout.step2.customValidation.editAddress",
            generalException: "checkout.step2.customValidation.generalException",
            surepostException: "checkout.step2.customValidation.surepostException",
            upsException: "checkout.step2.customValidation.upsException",
        },
        formErrorFromPayment: {
            validation: "checkout.step2.formErrorFromPayment.Validation",
            addressObjectMissing: "checkout.step2.formErrorFromPayment.AddressObjectMissing",
            postCodeMissing: "checkout.step2.formErrorFromPayment.PostCodeMissing",
            streetNameMissing: "checkout.step2.formErrorFromPayment.StreetNameMissing",
            addressInvalid: "checkout.step2.formErrorFromPayment.AddressInvalid",
            nameAndLastNameOrCompanyNameMissing:
                "checkout.step2.formErrorFromPayment.NameAndLastNameOrCompanyNameMissing",
            CCStoreAddressInvalid: "checkout.step2.formErrorFromPayment.CCStoreAddressInvalid",
            deliveryMethodInvalid: "checkout.step2.formErrorFromPayment.DeliveryMethodInvalid",
        },
    },
    step3: {
        title: "checkout.step3.title",
        spinnerTitle: "checkout.step3.spinner.title",
        spinnerSubtitle: "checkout.step3.spinner.subtitle",
        orderCreation: "checkout.step3.orderCreation",
        paymentProcessing: "checkout.step3.paymentProcessing",
        dropinComponent: "checkout.step3.dropinComponent",
        dropinError: "checkout.step3.dropin.error",
        dropinSessionError: "checkout.step3.dropin.sessionError",
        zeroAmountMessage: "checkout.step3.dropin.zeroAmountMessage",
        zeroAmountButton: "checkout.step3.dropin.zeroAmountButton",
        zeroAmountErrorMessage: "checkout.step3.dropin.zeroAmountErrorMessage",
        zeroAmountTotal: "checkout.step3.dropin.zeroAmountTotal",
        paymentProcessingHeader: "checkout.step3.paymentProcessingHeader",
        paymentProcessingMessage: "checkout.step3.paymentProcessingMessage",
        dropinRefusalReasonCodes: (refusalReasonCode: string | number) =>
            `checkout.step3.dropinRefusalReasonCodes.${refusalReasonCode}`,
    },
    amazonPay: {
        disclaimer: "amazonPay.disclaimer",
    },
    trust: {
        securePayment: "checkout.trust.securePayment",
        returns: "checkout.trust.returns",
        officialStore: "checkout.trust.officialStore",
    },
};

export default Checkout;
